import { useEffect, useState } from 'react';

import { useYearQuarterNavigation } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import {
  getCapacitySettings,
  saveCapacitySettings
} from 'RestAPIs/capacity-settings';

import { scenarioAtom } from '../../../atoms';

import { Select, showSnackbar } from 'components/shared';

import { LEAVE_TYPES } from '../../const';

const LeaveTypeSelect = () => {
  const { t } = useTranslation('common');
  const scenario = useRecoilValue(scenarioAtom);
  const { year } = useYearQuarterNavigation();
  const [selectedLeaveType, setSelectedLeaveType] = useState<
    keyof typeof LEAVE_TYPES | null
  >(null);

  useEffect(() => {
    if (!scenario) {
      return;
    }

    getCapacitySettings(scenario.scenarioId, year).then(({ data }) => {
      if (data.leaveType) {
        setSelectedLeaveType(data.leaveType);
      }
    });
  }, [scenario, year]);

  const saveLeaveType = (value: keyof typeof LEAVE_TYPES) => {
    if (!value || !scenario) {
      return;
    }

    saveCapacitySettings({
      scenarioId: scenario.scenarioId,
      year,
      payload: { leaveType: value }
    })
      .then(() => {
        showSnackbar({
          severity: 'success',
          message: t('changesSaved')
        });
      })
      .catch(() => {
        showSnackbar({
          severity: 'error',
          message: t('somethingWentWrong')
        });
      });
  };

  const onChangeSelectedLeaveType = (value: keyof typeof LEAVE_TYPES) => {
    if (selectedLeaveType !== value) {
      setSelectedLeaveType(value);
      saveLeaveType(value);
    }
  };

  const options = [
    LEAVE_TYPES.PREDICTED_LEAVE,
    LEAVE_TYPES.PLANNED_LEAVE,
    LEAVE_TYPES.PLANNED_AND_REQUESTED_LEAVE
  ];

  return (
    <Select
      label={t('nonProductiveHours.typeOfLeave')}
      valueProp={selectedLeaveType ?? undefined}
      onSelected={onChangeSelectedLeaveType}
      options={options.map((type) => ({
        label: t(`formation.${type}`),
        value: type
      }))}
    />
  );
};

export default LeaveTypeSelect;
